import React, { type FunctionComponent } from 'react';

import { FormLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminSettingsContainer from '../AdminSettingsContainer';
import SaveButton from '../components/SaveButton';
import { OrganizationType } from '../config/adminSettingsConfig';
import StyledFormTitle from '../styles/form-title';
import { AdminControlCheckbox } from '../utils/AdminControlCheckbox';

const StyledFormGroupContainer = styled.div`
    margin-left: 10px;
    margin-bottom: 19px;
`;

const StyledOrganizationInfoContainer = styled.div`
    margin-bottom: 20px;
`;

const StyledFormLabelContainer = styled.div`
    margin-bottom: 5px;
`;

const GeneralSettings: FunctionComponent = () => {
    const { adminSettings, setAdminSettings, organizationName, isSavingSettingsData, handleSaveSettings } =
        useContainer(AdminSettingsContainer);
    const { t } = useTranslation('admin_settings');

    const handleChange = (event) => {
        setAdminSettings({ ...adminSettings, organizationType: event.target.value });
    };

    return (
        <>
            <StyledFormTitle>{t('general.title')}</StyledFormTitle>
            <StyledFormGroupContainer>
                <StyledFormLabelContainer>
                    <FormLabel component="legend">{t('general.formLabel')}</FormLabel>
                </StyledFormLabelContainer>
                <RadioGroup
                    aria-label={t('general.formLabel')}
                    name="organizationType"
                    value={adminSettings.organizationType}
                    onChange={handleChange}
                >
                    <AdminControlCheckbox
                        control={<Radio value={OrganizationType.Academic} />}
                        label={t('general.academicLabel') as string}
                    />
                    <AdminControlCheckbox
                        control={<Radio value={OrganizationType.Corporate} />}
                        label={t('general.corporateLabel') as string}
                    />
                </RadioGroup>
            </StyledFormGroupContainer>
            <StyledOrganizationInfoContainer>
                {organizationName && (
                    <Typography variant="body1">{`${t('general.organizationName')} ${organizationName}`}</Typography>
                )}
            </StyledOrganizationInfoContainer>
            <SaveButton isSaving={isSavingSettingsData} onClick={handleSaveSettings} />
        </>
    );
};

export default GeneralSettings;
